import { useCallback, useState } from 'react';

import { EditOption } from '../types';

export const SEARCH_VISIBILITY_THRESHOLD = 8;

export type OptionSearch = {
  search: string;
  filteredOptions: Array<EditOption>;
  hasActiveSearch: boolean;
  isSearchVisible: boolean;
  onSearchChange(value: string): void;
  reset(): void;
};

// The search box is controlled from here, so what the user typed is kept as
// they typed it and only lowercased to compare. The editors reset it as the
// popover opens: a cell stays mounted for the life of the table, so without
// that the next open reopens onto the last search.
export const useOptionSearch = (options: Array<EditOption>): OptionSearch => {
  const [search, setSearch] = useState('');
  const query = search.trim().toLowerCase();
  const hasActiveSearch = query !== '';

  const filteredOptions = hasActiveSearch
    ? options.filter((option) => option.label.toLowerCase().includes(query))
    : options;

  return {
    search,
    filteredOptions,
    hasActiveSearch,
    isSearchVisible: options.length > SEARCH_VISIBILITY_THRESHOLD,
    onSearchChange: setSearch,
    reset: useCallback(() => setSearch(''), []),
  };
};
